import { render, staticRenderFns } from "./TeamOverviewRelation.vue?vue&type=template&id=71564308&scoped=true&"
import script from "./TeamOverviewRelation.vue?vue&type=script&lang=js&"
export * from "./TeamOverviewRelation.vue?vue&type=script&lang=js&"
import style0 from "./TeamOverviewRelation.vue?vue&type=style&index=0&id=71564308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71564308",
  null
  
)

export default component.exports